import $ from 'jquery';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

import 'mapbox-gl/dist/mapbox-gl.css';
import mapboxgl from 'mapbox-gl';

/*
 *
 * Carte interactive
 *
*/
const map = {

	parameters : null,

	lmap: null,
	container: '',
	maps: [],

	type: '',
	lat: '',
	lng: '',
	height: '',
	zoom: '',
	apiKey: '',
	tiles: '',
	URL: '',

	all: null,
	clusterLayer: null,
	markersJSON: '',
	markers: [],
	markersTemp: [],
	lmarker: null,
	activeMarkers: new Array(),
	bounds: new Array(),

	/* ----------------------------------------------------- */
	/* INITIALISATION DU MODULE */
	/* ----------------------------------------------------- */
	init : function() {
		map.events();
		map.markers = [];
		map.maps = [];

		/* Parametres d'initialisation des maps */
		/* ----------------------------------------------------- */
		if ( $('.items_map_parameters').length > 0 ) {

			$('.items_map_parameters').each(function(i,e) {

				map.parameters = $(e);
				map.container = map.parameters.data('container');
				map.markersJSON = map.parameters.data('markers');
				map.type = map.parameters.data('type');
				map.lat = map.parameters.data('lat');
				map.lng = map.parameters.data('lng');
				map.height = map.parameters.data('height');
				map.zoom = map.parameters.data('zoom');
				// console.log(map.zoom);
				map.tiles = map.parameters.data('tiles');
				map.apiKey = map.parameters.data('apikey');
				map.cluster = map.parameters.data('cluster');

				switch ( map.type ) {
					case 'gmap' :
						map.gmap();
					break;

					case 'osm' :
						map.osm();
					break;

					case 'ign' :
						map.ign();
					break;

					case 'mapbox' :
						map.mapbox();
					break;

					default :
						alert( 'Veuillez indiquer un type de carte' );
					break;
				}

			});
		}


		if ( $('#map_parameters').length > 0 ) {

			map.parameters = $('#map_parameters');
			map.container = map.parameters.data('container');
			map.markersJSON = map.parameters.data('markers');
			map.type = map.parameters.data('type');
			map.lat = map.parameters.data('lat');
			map.lng = map.parameters.data('lng');
			map.height = map.parameters.data('height');
			map.zoom = map.parameters.data('zoom');
			map.tiles = map.parameters.data('tiles');
			map.apiKey = map.parameters.data('apikey');
			map.cluster = map.parameters.data('cluster');

			switch ( map.type ) {
				case 'gmap' : map.gmap(); break;
				case 'osm' : map.osm(); break;
				case 'ign' : map.ign(); break;
				case 'mapbox' : map.mapbox(); break;
				default : alert( 'Veuillez indiquer un type de carte' ); break;
			}
		}
	},

	/* ----------------------------------------------------- */
	/* REINITIALISATION QUAND ON CHANGE DE TAILLE OU DISPLAY */
	/* ----------------------------------------------------- */
	reinit : function() {
		if ( map.maps.length > 0 ) {

			for (var i = 0; i < map.maps.length; i++) {
				var themap = map.maps[i];
				themap.remove();

				setTimeout(function() {
					map.init();
				}, 200);

			}
		}
		else if ( map.lmap !== null ) {
			map.lmap.invalidateSize();
		}
	},

	/* ----------------------------------------------------- */
	/* EVENEMENTS */
	/* ----------------------------------------------------- */
	events : function() {

		$(document)
			/* Fermeture de la popup de carte */
			/* ----------------------------------------------------- */
			.on('click', '.map_popup_close', function() {
				map.hidePopup();
			})


			/* Selection d'un point quand on clique sur son item */
			/* ----------------------------------------------------- */
			.on('click', '.object .select-marker', function(e) {
				e.preventDefault();
				$('.objects-list .object').removeClass('active');
				$(this).parents('.object').toggleClass('active');
				map.selectMarker($(this).data('lat'), $(this).data('lng'));
			})

			/* Ouverture des filtres */
			/* ----------------------------------------------------- */
			.on('click', '.btn-toggle-map-search', function(e) {
				e.preventDefault();

				$('body').addClass('map-search-open');
			})

			/* Ouverture des filtres */
			/* ----------------------------------------------------- */
			.on('click', '.filters_container__close', function(e) {
				e.preventDefault();

				$('body').removeClass('map-search-open');
			})

			/* Filtrage de la map en fonction des filtres choisis */
			/* ----------------------------------------------------- */
			.on('click', '.valid_filters', function(event) {
				event.preventDefault();

				var tags = new Array();

				$('.btn-tag-map.active').each(function(i, el) {
					tags.push($(el).data('tag-id'));
				});

				map.filterMarkers( tags );

				$('body').removeClass('map-search-open');

				// rgaa.mapUpdated();
			})

			/* Filtrage par tag */
			/* ----------------------------------------------------- */
			.on('click', '.btn-tag-map', function(e) {
				// e.preventDefault();
				$(this).toggleClass('active');

				// map.lmap.closePopup();

				var tags = [];

				$($(this).data('tags-container')).find('.btn-tag-map').each(function(i,e) {
					if ( $(e).hasClass('active') ) {
						tags.push($(e).data('tag-id'));
					}
				});

				map.filterMarkers( tags );
				// rgaa.mapUpdated();

			})

			/* Redirection vers la map au changement de select sur la home */
			/* ----------------------------------------------------------- */
			.on('change', '.map__content__categories select', function(e) {
				var url = $(this).data('page'), cat = $(this).val();

				window.location.href = url + '?cat=' + cat;
			})
		;
	},

	/* ----------------------------------------------------- */
	/* GOOGLE MAPS */
	/* ----------------------------------------------------- */
	gmap : function() {
		map.tiles = '';
	},

	/* ----------------------------------------------------- */
	/* OPEN STREET MAP */
	/* ----------------------------------------------------- */
	osm : function() {

		if ( map.tiles == '' ) {
			map.tiles = "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png";
		}

		if ( map.height != '' ) {
			$('#' + map.container).css('height', map.height + ' !important');
		}

		if ( !$('#' + map.container).hasClass('leaflet-container') ) {
			map.lmap = new L.map(
				map.container,
				{
					attributionControl: true,
					worldCopyJump: true,
					scrollWheelZoom: false,
					minZoom: 4,
					maxZoom: 18
				}
			).setView(
				[
					map.lat,
					map.lng
				],
				map.zoom
			);

			// map.lmap.on('load', rgaa.modifyMap);

			/* Ajout au tableau de maps */
			/* ----------------------------------------------------- */
			map.maps.push(map.lmap);

			/* Creation des POI sur la map */
			/* ----------------------------------------------------- */
			map.createMarkers();

			L.tileLayer(
				map.tiles,
				{
					tileSize: 512,
					zoomOffset: -1,
					attribution: '© <a href="https://www.mapbox.com/contribute/">Mapbox</a> © <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
				}
			).addTo(map.lmap);

			// Image
			// var latlngImage = L.latLngBounds([[0,0], [4096,1024]]);
			// var imageOverlay = L.imageOverlay('/content/themes/wazachild/assets/images/custom-map.png', latlngImage, {
			// 	opacity: 1,
			// 	interactive: true
			// }).addTo(map.lmap);

			// L.rectangle(latlngImage);

			// map.lmap.fitBounds(latlngImage);

			// L.control.layers(null, overlaysMap, {collapsed: false}).addTo(lmap);

			// $('.leaflet-control-layers-list').prepend('<label>Legende</label>');

			// all.addTo(lmap)
		}

	},

	/* ----------------------------------------------------- */
	/* IGN */
	/* ----------------------------------------------------- */
	ign : function() {

		map.URL = "https://wxs.ign.fr/" + map.apiKey + "/geoportail/wmts?" +
			"&REQUEST=GetTile&SERVICE=WMTS&VERSION=1.0.0" +
			"&STYLE=normal" +
			"&TILEMATRIXSET=PM" +
			"&FORMAT=image/jpeg"+
			"&LAYER=ORTHOIMAGERY.ORTHOPHOTOS"+
			"&TILEMATRIX={z}" +
			"&TILEROW={y}" +
			"&TILECOL={x}"
		;


		if ( map.height > 0 ) {
			$('#' + map.container).css('height', map.height + ' !important');
		}

		var lmap = new L.map(
				map.container
			).setView(
				[
					map.lat,
					map.lng
				],
			map.zoom
		);

		L.tileLayer(
			map.URL,
			{
				minZoom : 0,
				maxZoom : 18,
				attribution : "IGN-F/Geoportail",
				tileSize : 256
			}
		).addTo(map.lmap) ;
	},

	/* ----------------------------------------------------- */
	/* MAPBOX */
	/* ----------------------------------------------------- */
	mapbox : function() {
		// map = this;

		mapboxgl.accessToken = map.apiKey;

		map.lmap = new mapboxgl.Map({
			container: map.container,
			tileSize: 512,
			style: map.tiles,
			center: [map.lng, map.lat],
			zoom: map.zoom,
			scrollZoom: false,
			renderWorldCopies: false,
		});

		if ( map.height != '' ) {
			$('#' + map.container).css('height', map.height + ' !important');
		}

		var nav = new mapboxgl.NavigationControl({
			showCompass: true,
			showZoom: true
		});

		map.lmap.addControl(nav, 'top-left');

		/* CREATION DES LEGENDES */
		/* ----------------------------------------------------- */
		// if ( catsArray.length > 0 ) {
		// 	var text = "";
		// 	text += "<div class='tags-container'>";

		// 	for (var j = 0; j < catsArray.length; j++) {
		// 		var cat = catsArray[j];
		// 		text += '<a href="" class="btn-tag-map active" data-tags-container=".tags-container" data-tag-id="' + cat.term_id + '" ><img src="../../images/map/marker_' + cat.slug + '.png" /><span>' + cat.name + '</span></a>';
		// 	}

		// 	text += "</div>";
		// 	$('#map_legend').html(text);
		// }

		map.lmap.resize();

		/* CREATION DES MARKERS */
		/* ----------------------------------------------------- */
		map.createMarkers();
	},

	/* ----------------------------------------------------- */
	/* MARKERS */
	/* ----------------------------------------------------- */
	/*
		* Cree les markers a mettre sur la carte
		*
		* markersArray ( array/null ) : tableau de markers filtres
		* init ( bool ) : initialisation de la map ou filtrage. Si filtrage, on ne recree pas tous les markers
	*/
	createMarkers : function( markersArray = null, init = true ) {
		var markers = new Array;

		if ( markersArray !== null ) {
			markers = markersArray;
		}
		else if ( $('#' + map.markersJSON).length ) {
			markers = JSON.parse( $('#' + map.markersJSON).val() );
		}
		else if ( $('#map_markers').length ) {
			try {
				markers = JSON.parse( $('#map_markers').val() );
			}
			catch (e) {
				console.log($('#map_markers').val());
			}
		}
		else if ( map.markers.length > 0 ) {
			markers = map.markers;
		}

		if ( markers.length > 0 ) {
			switch (map.type) {
				case 'gmap':
				break;

				case 'osm':

					/* Creation d'un cluster de points */
					/* ----------------------------------------------------- */
					if ( map.cluster ) {
						map.clusterLayer = L.markerClusterGroup({
							showCoverageOnHover: true,
							// zoomToBoundsOnClick: true,
							// removeOutsideVisibleBounds: true,
							spiderfyOnMaxZoom: true,
							// singleMarkerMode: true,
						});

						/* Ajout du layer de cluster a la map */
						/* ----------------------------------------------------- */
						map.lmap.addLayer(map.clusterLayer);
						// map.lmap.fitBounds(new L.featureGroup(map.markers).getBounds());
					} else {
						map.clusterLayer = L.layerGroup();
						map.lmap.addLayer(map.clusterLayer);
					}

					map.markersTemp = [];

					for (var i = 0; i < markers.length; i++) {
						var marker = markers[i];
						// console.log(marker.lat, marker.lng);
						if (
							marker.lat !== null &&
							marker.lat !== 0 &&
							marker.lat !== '' &&
							marker.lng !== null &&
							marker.lng !== 0 &&
							marker.lng !== ''
						) {
							//console.log(marker);
							map.createMarker(marker, init);
						}
					}

					/* Boundaries */
					/* ----------------------------------------------------- */
					if ( markers.length > 1 ) {
						var bounds = new L.featureGroup(map.markersTemp);
						map.lmap.fitBounds(bounds.getBounds());
					}
				break;

				case 'ign':
				break;

				case 'mapbox':
					for (var i = 0; i < markers.length; i++) {
						var marker = markers[i];
						map.createMarker(marker, init);
					}
				break;

			}
		}

	},

	/* Creation d'un marker unique */
	/* ----------------------------------------------------- */
	/*
		* createMarker
		* marker ( Marker ) : objet marker
		* init ( Bool ) : verifie si on est a l'initialisation ou non
		*/
	createMarker : function( marker, init = true ) {
		switch ( map.type ) {
			case 'gmap':
			break;

			case 'osm':

				var pattern = /^-?[\d]{1,3}[.][\d]+$/;

				if ( pattern.test(marker['lat']) && pattern.test(marker['lng']) ) {
					var coords = L.latLng(marker['lat'], marker['lng']);

					/* si les coordonnees sont correctes */
					if ( coords ) {
						var lmarker = L.marker(
							[
								marker['lat'],
								marker['lng']
							],
							{
								riseOnHover: true,
								alt: marker['title'],
								title: marker['title'],
							}
						);

						map.markersTemp.push(lmarker);

						map.clusterLayer.addLayer(lmarker);

						// if ( map.cluster ) {
						// } else {
						// 	lmarker.addTo(map.lmap);
						// }

						/* Changement de l'icon de base */
						/* ----------------------------------------------------- */
						var iconUrl = '';

						if ( marker['type'] ) {
							iconUrl = marker['type'] + '.svg';
						} else {
							iconUrl = 'default.svg';
						}

						var icon = L.icon(
							{
								iconUrl: site_url.url + '/assets/images/map/marker_' + iconUrl,
								iconSize: [40, 48],
								iconAnchor: [20, 48],
								popupAnchor: [0, -48],
							}
						);
						// var icon = L.divIcon(
						// 	{
						// 		html: '<img src="' + site_url.url + '/assets/images/map/marker_' + iconUrl + '" class="leaflet-div-icon-bg">' + '<img src="' + marker['image'] + '" class="leaflet-div-icon-image">',
						// 		iconSize: [54, 70],
						// 		iconAnchor: [27, 70],
						// 		popupAnchor: [0, -70],
						// 	}
						// );

						if (icon) {
							lmarker.setIcon(icon);
						}

						if ( init ) {
							map.markers.push(lmarker);
						}

						lmarker.id = marker['id'];
						lmarker.class = iconUrl;
						lmarker.title = marker['title'];
						lmarker.content = marker['content'];
						lmarker.image = marker['image'];
						lmarker.link = marker['link'];
						lmarker.type = marker['type'];

						lmarker.on('click', function(e) {
							// rgaa.modifyMap();
						});

						var popup = map.createPopup(lmarker);
						lmarker.bindPopup(popup);
					}
				}
			break;

			case 'ign':
			break;

			case 'mapbox':

				var el = document.createElement('div');
				el.className = 'marker';

				var lmarker = new mapboxgl.Marker({
						'color' : '#13a538',
						'anchor' : 'bottom',
					})
					.setLngLat([marker.lng, marker.lat])
					.addTo(map.lmap);

				lmarker.id = marker.id;
				lmarker.title = marker.title;
				lmarker.content = marker.content;
				lmarker.image = marker.image;
				lmarker.link = marker.link;
				lmarker.type = marker.type;

				var popup = map.createPopup(lmarker);

				lmarker.setPopup(popup);

				if ( init ) {
					map.markers.push(lmarker);
				}

			break;

		}

	},

	/* Cree une liste d'objets cliquables */
	/* ----------------------------------------------------- */
	createMarkersList : function( markers ) {

		// On recree la popup
		var popup = '<div class="objects-list">';

				for (var i = 0; i < markers.length; i++) {
					var mrkr = markers[i];
					popup += '<div class="object">';

						popup += '<a href="" class="select-marker" data-lat="' + mrkr.lat + '" data-lng="' + mrkr.lng + '">' + mrkr.title + '</a>';
								popup += '<div class="object-actions">';
									//popup += '<div class="object-position"><a href="" class="select-marker" data-lat="' + mrkr.lat + '" data-lng="' + mrkr.lng + '"><i class="fas fa-map-marker-alt"></i></a></div>';
									popup += '<div class="object-link"><a href="' + mrkr.link + '"><i class="fas fa-angle-right"></i></a></div>';
								popup += '</div>';
						popup += '</a>';

					popup += '</div>';
				}
		popup += '</div>';

		return popup;

	},

	/* Filtre les markers en fonction des tags */
	/* ----------------------------------------------------- */
	filterMarkers : function( tags ) {

		map.activeMarkers = [];

		for ( var i = 0; i < map.markers.length; i++ ) {
			var marker = map.markers[i];
			var active = false;
			var nbfiltres = 0;
			var nbfiltresOK = 0;

			// Si aucun tag
			if ( tags.length == 0 ) {
				active = true;
			}
			else {
				if ( tags.indexOf(marker.type) >= 0 ) {
					active = true;
				}
			}

			if ( active ) {
				// console.log(marker);
				// marker.removeFrom(map.lmap);
				marker.setOpacity(1);
				map.activeMarkers.push(marker);
			}
			else {
				// $('.mapboxgl-marker').remove();
				// marker.removeFrom(map.lmap);
				marker.setOpacity(0);
			}

		}

		/* Boundaries */
		/* ----------------------------------------------------- */
		if ( map.activeMarkers.length > 0 ) {
			var bounds = new L.featureGroup(map.activeMarkers);
			map.lmap.fitBounds(bounds.getBounds());
			// map.refreshMarkers(map.activeMarkers);
		}
	},

	/* Rafraichit l'affichage des clusters */
	/* ----------------------------------------------------- */
	refreshMarkers : function() {

		switch ( map.type ) {
			case 'gmap':
			break;

			case 'osm':
			case 'ign':

				// map.clusterLayer.clearLayers();

				if ( map.activeMarkers ) {
					var activeMarkersArray = new Array();

					for ( var j = 0; j < map.activeMarkers.length; j++ ) {

						var marker = map.activeMarkers[j], lmarker = new Array();

						lmarker['id'] = marker.id;
						lmarker['title'] = marker.title;
						lmarker['content'] = marker.content;
						lmarker['image'] = marker.image;
						lmarker['link'] = marker.link;
						lmarker['tags'] = marker.tags;
						lmarker['lat'] = marker.getLatLng().lat;
						lmarker['lng'] = marker.getLatLng().lng;
						lmarker['type'] = marker.type,
						lmarker['region'] = marker.region,
						lmarker['typology'] = marker.typology,
						lmarker['thematic'] = marker.thematic;

						activeMarkersArray.push(lmarker);
					}
				}

			break;

			case 'mapbox':
				if ( map.activeMarkers ) {
					var activeMarkersArray = new Array();

					for ( var j = 0; j < map.activeMarkers.length; j++ ) {

						var marker = map.activeMarkers[j], lmarker = new Array();

						lmarker['id'] = marker.id;
						lmarker['title'] = marker.title;
						lmarker['content'] = marker.content;
						lmarker['image'] = marker.image;
						lmarker['link'] = marker.link;
						lmarker['tags'] = marker.tags;
						lmarker['lat'] = marker.getLngLat()['lat'];
						lmarker['lng'] = marker.getLngLat()['lng'];

						activeMarkersArray.push(lmarker);
					}

				}
			break;

		}

		map.createMarkers(activeMarkersArray, false);

	},

	/* Selectionne un marker en fonction du click sur un item */
	/* ------------------------------------------------------ */
	selectMarker : function( lat, lng ) {

		for (var i = map.markers.length - 1; i >= 0; i--) {
			marker = map.markers[i];

			if ( marker._latlng['lat'] == lat && marker._latlng['lng'] == lng ) {
				map.cluster.zoomToShowLayer(marker);
				marker.openPopup();
			}
		}

	},

	/* ----------------------------------------------------- */
	/* INFOWINDOW */
	/* ----------------------------------------------------- */
	createPopup : function(marker) {

		// On recree la popup
		var popup, p = '';

		if ( marker.title != '' ) {
			popup = '';
			popup += '<div class="map_popup">';
				popup += '<div class="map_popup_content ';
					if ( marker.image == '' ) {
						popup += ' no_image';
					}
				popup += '">';

					if ( marker.link != '' ) { popup += '<a href="' + marker.link + '">'; }

						if ( marker.image != '' ) {
							popup += '<div class="map_popup_content_image">';
								popup += '<img src="' + marker.image + '" />';
							popup += '</div>';
						}

						if ( marker.type != '' ) {
							popup += '<div class="map_popup_content_type">';
								popup += '<button type="button" role="button" class="btn btn-'+marker.type+'">' + marker.type + '</button>';
							popup += '</div>';
						}

						if ( marker.title != '' || marker.content != '' ) {
							popup += '<div class="map_popup_content_container">';
								if ( marker.title != '' ) { popup += '<p class="map_popup_content_titre">' + marker.title + '</p>'; }
								if ( marker.content != '' ) { popup += '<div class="map_popup_content_texte"><p>' + marker.content.replace("|", "<br>") + '</p></div>'; }
							popup += '</div>';
						}

					if ( marker.link != '' ) { popup += '</a>'; }

				popup += '</div>';
			popup += '</div>';

			if ( popup != '' ) {

				switch ( map.type ) {
					case 'gmap':
					break;

					case 'osm':
					case 'ign':
						p = L.popup({
							minWidth: 250,
							maxWidth: 350,
						}).setContent(popup);
					break;

					case 'mapbox':
						var coords = marker.getLngLat();
						var p = new mapboxgl.Popup({
							closeButton: false,
						})
						.setMaxWidth("240px")
						.setLngLat([coords.lng, coords.lat])
						.setHTML(popup);
					break;

				}
			}
		}

		return p;

	},

	/* ----------------------------------------------------- */
	/* POPUPWINDOW */
	/* ----------------------------------------------------- */
	popupWindow : function(item) {

		// On vide la popup si elle etait visible
		$('#map_popup_container').empty();

		var titre, texte, image, lien, popup;

		titre = item.titre;
		texte = item.texte;
		image = item.image;
		lien = item.lien;

		// On recree la popup
		popup = '<div class="map_popup">';
			popup += '<div class="map_popup_content">';
				popup += '<div class="map_popup_close"><i class="icn icn-cross"></i></div>';
				if ( lien != '' ) { popup += '<a href="' + lien + '">'; }
					if ( image != '' ) { popup += '<div class="map_popup_content_image"><img src="' + image.sizes.medium + '" /></div>'; }
					if ( titre != '' ) { popup += '<p class="map_popup_content_titre">' + titre + '</p>'; }
					if ( texte != '' ) { popup += '<p class="map_popup_content_texte">' + texte + '</p>'; }
				if ( lien != '' ) { popup += '</a>'; }
			popup += '</div>';
		popup += '</div>';

		// Position du point
		var top = $('g#town-' + item.ville.value).position().top;
		var left = $('g#town-' + item.ville.value).position().left;

		// Position du parent
		var ptop = $('#carteinteractive').position().top;
		var pleft = $('#carteinteractive').position().left;

		$(popup).appendTo('#map_popup_container');
		map.showPopup((top - ptop), (left - pleft));

	},

	showPopup : function(top, left) {
		$('#map_popup_container').css({'top': top, 'left': left});
		$('#map_popup_container').addClass('open');
	},

	hidePopup : function() {
		$('#map_popup_container').removeClass('open');
	}

};

/* ----------------------------------------------------- */
/* ON READY */
/* ----------------------------------------------------- */
$(function() {
	$('.wazablocks__map:not(.leaflet-container )').each(function() {
		map.init();
	});
});

// Initialize dynamic block preview (editor).
if( window.acf ) {
	window.acf.addAction( 'render_block_preview/type=map', map.init );
}